import { render } from "./EditableItemTeacherClasses.vue?vue&type=template&id=9419d27a&scoped=true&ts=true"
import script from "./EditableItemTeacherClasses.vue?vue&type=script&lang=ts"
export * from "./EditableItemTeacherClasses.vue?vue&type=script&lang=ts"

import "./EditableItemTeacherClasses.vue?vue&type=style&index=0&id=9419d27a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9419d27a"]])

export default __exports__